import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

interface SelectedDateState {
  selectedDate: string;
}

export const BIRTHDAY_SELECTED_DATE_STORAGE_KEY = "birthday_selected_date";

const readStoredDate = (): string | null => {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage.getItem(
      BIRTHDAY_SELECTED_DATE_STORAGE_KEY
    );
    return stored && moment(stored, "DD/MM/YYYY", true).isValid()
      ? stored
      : null;
  } catch {
    return null;
  }
};

const writeStoredDate = (date: string): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(BIRTHDAY_SELECTED_DATE_STORAGE_KEY, date);
  } catch {
    // ignore storage errors (e.g. private browsing)
  }
};

/**
 * The restored date should only survive an F5 while the user stays within
 * the same login session and on this screen — call on leaving the screen
 * or logging out so a later visit/session starts from today again.
 */
export const clearStoredSelectedDate = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(BIRTHDAY_SELECTED_DATE_STORAGE_KEY);
  } catch {
    // ignore storage errors (e.g. private browsing)
  }
};

const initialState: SelectedDateState = {
  selectedDate: readStoredDate() ?? moment().format("DD/MM/YYYY"),
};

const selectedDateSlice = createSlice({
  name: "birthdaySelectedDate",
  initialState,
  reducers: {
    setSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
      writeStoredDate(action.payload);
    },
    resetSelectedDate: (state) => {
      const todayStr = moment().format("DD/MM/YYYY");
      state.selectedDate = todayStr;
      writeStoredDate(todayStr);
    },
  },
});

export const { setSelectedDate, resetSelectedDate } = selectedDateSlice.actions;

export default selectedDateSlice.reducer;
